import React from "react";
import { Select, SelectOption } from "@showitinc/showit-wc";

import AppConstants from "../constants/AppConstants";
import ActiveBlockContainerStore from "../stores/ActiveBlockContainerStore.mjs";
import useStoreState from "./providers/useStoreState";
import { formatPropUpdate } from "../utils/PropertyUtils";
import { isBlockTargetValid } from "../utils/LinkUtils";

const { VISIBLE_NONE, VALUE_THIS, DISABLED_DIVIDER, SELECT_EMPTY_OPTION_TEXT } = AppConstants;

const BlockSelectInput = ({ isLocked, propName, value: passedValue, label, onChange }) => {
  const activeContainer = useStoreState(
    ActiveBlockContainerStore,
    ActiveBlockContainerStore.getContainer
  );
  const blocks = activeContainer.get("blocks");

  const value = isBlockTargetValid(passedValue) ? passedValue : null;

  return (
    <Select
      disabled={isLocked}
      label={label}
      value={value}
      reserveContext
      onSISelect={(e) => onChange(formatPropUpdate(propName, e.target.value, value))}
      shift="left"
      filter
    >
      <SelectOption value="">{SELECT_EMPTY_OPTION_TEXT}</SelectOption>
      <SelectOption value={VALUE_THIS}>This Canvas</SelectOption>
      <SelectOption value="disabled" disabled>
        {DISABLED_DIVIDER}
      </SelectOption>
      {blocks.map((block) =>
        block.get("visible") !== VISIBLE_NONE ? (
          <SelectOption key={`opt-${block.get("slug")}`} value={block.get("slug")}>
            {block.get("name")}
          </SelectOption>
        ) : null
      )}
    </Select>
  );
};

export default BlockSelectInput;
